var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09107 10.5829H16.8498C17.0376 10.5829 17.1899 10.4306 17.1899 10.2428V9.18715C17.1899 9.07555 17.1355 8.97221 17.0457 8.90959L10.165 4.06125C10.048 3.97958 9.89022 3.97958 9.77323 4.06125L2.89515 8.90959C2.80534 8.97221 2.75098 9.07831 2.75098 9.18715V10.2428C2.75085 10.4305 2.90329 10.5828 3.09103 10.5828L3.09107 10.5829ZM9.96915 6.31942C10.6521 6.31942 11.2043 6.87169 11.2043 7.55459C11.2043 8.2375 10.6521 8.78976 9.96915 8.78976C9.28625 8.78976 8.73398 8.2375 8.73398 7.55459C8.73386 6.87182 9.28625 6.31942 9.96915 6.31942Z",
    fill: "url(#paint0_linear_3414_10044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64844 17.9234V18.4947H7.12017V17.9234C7.12017 17.8092 7.02498 17.7139 6.91062 17.7139L3.85814 17.714C3.74115 17.7166 3.64859 17.8092 3.64859 17.9234L3.64844 17.9234Z",
    fill: "url(#paint1_linear_3414_10044)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12017 11.1189H3.64844V11.6902C3.64844 11.8044 3.74363 11.8997 3.85799 11.8997H6.9106C7.02483 11.8997 7.12016 11.8045 7.12016 11.6902L7.12017 11.1189Z",
    fill: "url(#paint2_linear_3414_10044)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23047 17.9233V18.4946L11.7077 18.4947V17.9234C11.7077 17.8092 11.6125 17.7139 11.4981 17.7139H8.44274C8.32575 17.7165 8.23055 17.8091 8.23055 17.9233L8.23047 17.9233Z",
    fill: "url(#paint3_linear_3414_10044)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7077 11.1189H8.23047V11.6902C8.23047 11.8044 8.32567 11.8997 8.44265 11.8997H11.4953C11.6095 11.8997 11.7048 11.8045 11.7048 11.6902V11.1189H11.7077Z",
    fill: "url(#paint4_linear_3414_10044)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2896 11.6903V11.119L12.8179 11.1189V11.6902C12.8179 11.8044 12.9131 11.8997 13.0274 11.8997H16.08C16.197 11.8997 16.2895 11.8073 16.2895 11.6903L16.2896 11.6903Z",
    fill: "url(#paint5_linear_3414_10044)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7408 14.7185C15.0377 14.7185 13.6582 16.098 13.6582 17.7983C13.6582 19.5042 15.0403 20.8809 16.7408 20.8809C18.4412 20.8809 19.8233 19.5014 19.8233 17.7983C19.8233 16.0978 18.4412 14.7185 16.7408 14.7185V14.7185ZM16.7408 17.5316C17.3338 17.5316 17.8182 18.0159 17.8182 18.6117C17.8182 19.1124 17.4727 19.5314 17.0102 19.6511V19.9749C17.0102 20.1218 16.8905 20.2442 16.7409 20.2442C16.5912 20.2442 16.4716 20.1244 16.4716 19.9749L16.4714 19.6511C16.0061 19.5313 15.6606 19.1124 15.6606 18.6117C15.6606 18.4648 15.7803 18.3424 15.9299 18.3424C16.0796 18.3424 16.1992 18.4622 16.1992 18.6117C16.1992 18.911 16.4413 19.1532 16.7407 19.1532C17.0399 19.1532 17.2822 18.9111 17.2822 18.6117C17.2822 18.3125 17.04 18.0702 16.7407 18.0702C16.1448 18.0702 15.6606 17.586 15.6606 16.9928C15.6606 16.4921 16.0061 16.0705 16.4713 15.9508V15.627C16.4713 15.48 16.5911 15.3577 16.7406 15.3577C16.8903 15.3577 17.0099 15.4774 17.0099 15.627V15.9508C17.4751 16.0705 17.818 16.4895 17.818 16.9928C17.818 17.1397 17.6982 17.2621 17.5487 17.2621C17.399 17.2621 17.2794 17.1423 17.2794 16.9928C17.2794 16.6935 17.0372 16.4513 16.7379 16.4513C16.4386 16.4513 16.1964 16.6934 16.1964 16.9928C16.1966 17.2895 16.4415 17.5316 16.7408 17.5316H16.7408Z",
    fill: "url(#paint6_linear_3414_10044)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23926 12.4355H6.53006V17.1777H4.23926V12.4355Z",
    fill: "url(#paint7_linear_3414_10044)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82324 12.4355H11.114V17.1777H8.82324V12.4355Z",
    fill: "url(#paint8_linear_3414_10044)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3399 19.0334H3.06922C2.84614 19.0334 2.6665 19.2131 2.6665 19.4361V20.4836C2.6665 20.7067 2.84612 20.8863 3.06922 20.8863H14.8527C14.1588 20.4565 13.6228 19.8061 13.3399 19.0335V19.0334Z",
    fill: "url(#paint9_linear_3414_10044)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.699 14.3346V12.4355H13.4082V16.3805C13.8298 15.4037 14.6678 14.6446 15.699 14.3345V14.3346Z",
    fill: "url(#paint10_linear_3414_10044)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2673 24.3959H33.026C33.2138 24.3959 33.3661 24.2435 33.3661 24.0558V23.0001C33.3661 22.8885 33.3117 22.7852 33.2219 22.7226L26.3413 17.8742C26.2243 17.7926 26.0665 17.7926 25.9495 17.8742L19.0714 22.7226C18.9816 22.7852 18.9272 22.8913 18.9272 23.0001V24.0558C18.9271 24.2434 19.0796 24.3958 19.2673 24.3958L19.2673 24.3959ZM26.1454 20.1324C26.8283 20.1324 27.3806 20.6847 27.3806 21.3676C27.3806 22.0505 26.8283 22.6027 26.1454 22.6027C25.4625 22.6027 24.9102 22.0505 24.9102 21.3676C24.9101 20.6848 25.4625 20.1324 26.1454 20.1324Z",
    fill: "url(#paint11_linear_3414_10044)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8247 31.7364V32.3077H23.2964V31.7364C23.2964 31.6222 23.2012 31.5269 23.0869 31.5269L20.0344 31.527C19.9174 31.5296 19.8249 31.6222 19.8249 31.7364L19.8247 31.7364Z",
    fill: "url(#paint12_linear_3414_10044)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2964 24.9319H19.8247V25.5032C19.8247 25.6174 19.9199 25.7127 20.0343 25.7127H23.0869C23.2011 25.7127 23.2964 25.6175 23.2964 25.5032L23.2964 24.9319Z",
    fill: "url(#paint13_linear_3414_10044)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4067 31.7363V32.3076L27.884 32.3077V31.7364C27.884 31.6222 27.7888 31.5269 27.6744 31.5269H24.619C24.502 31.5295 24.4068 31.6221 24.4068 31.7363L24.4067 31.7363Z",
    fill: "url(#paint14_linear_3414_10044)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.884 24.9319H24.4067V25.5032C24.4067 25.6174 24.5019 25.7127 24.6189 25.7127H27.6716C27.7858 25.7127 27.8811 25.6175 27.8811 25.5032V24.9319H27.884Z",
    fill: "url(#paint15_linear_3414_10044)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4653 25.5033V24.932L28.9937 24.9319V25.5032C28.9937 25.6174 29.0888 25.7127 29.2032 25.7127H32.2558C32.3727 25.7127 32.4652 25.6203 32.4652 25.5033L32.4653 25.5033Z",
    fill: "url(#paint16_linear_3414_10044)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9171 28.531C31.214 28.531 29.8345 29.9105 29.8345 31.6109C29.8345 33.3168 31.2166 34.6935 32.9171 34.6935C34.6176 34.6935 35.9997 33.314 35.9997 31.6109C35.9997 29.9104 34.6176 28.531 32.9171 28.531V28.531ZM32.9171 31.3442C33.5102 31.3442 33.9946 31.8284 33.9946 32.4243C33.9946 32.9249 33.649 33.344 33.1865 33.4637V33.7875C33.1865 33.9344 33.0668 34.0568 32.9172 34.0568C32.7675 34.0568 32.6479 33.9371 32.6479 33.7875L32.6477 33.4637C32.1825 33.3439 31.8369 32.9249 31.8369 32.4243C31.8369 32.2774 31.9566 32.155 32.1062 32.155C32.2559 32.155 32.3755 32.2747 32.3755 32.4243C32.3755 32.7235 32.6176 32.9658 32.917 32.9658C33.2162 32.9658 33.4585 32.7237 33.4585 32.4243C33.4585 32.1251 33.2164 31.8828 32.917 31.8828C32.3211 31.8828 31.8369 31.3985 31.8369 30.8053C31.8369 30.3047 32.1824 29.883 32.6477 29.7633V29.4395C32.6477 29.2925 32.7674 29.1702 32.917 29.1702C33.0666 29.1702 33.1863 29.2899 33.1863 29.4395V29.7633C33.6515 29.883 33.9943 30.302 33.9943 30.8053C33.9943 30.9522 33.8745 31.0746 33.725 31.0746C33.5753 31.0746 33.4557 30.9549 33.4557 30.8053C33.4557 30.5061 33.2136 30.2638 32.9142 30.2638C32.615 30.2638 32.3727 30.5059 32.3727 30.8053C32.3729 31.102 32.6178 31.3442 32.9171 31.3442H32.9171Z",
    fill: "url(#paint17_linear_3414_10044)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4155 26.2485H22.7063V30.9908H20.4155V26.2485Z",
    fill: "url(#paint18_linear_3414_10044)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9995 26.2485H27.2903V30.9908H24.9995V26.2485Z",
    fill: "url(#paint19_linear_3414_10044)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5161 32.8464H19.2455C19.0224 32.8464 18.8428 33.026 18.8428 33.2491V34.2966C18.8428 34.5197 19.0224 34.6993 19.2455 34.6993H31.029C30.335 34.2694 29.7991 33.6191 29.5161 32.8465V32.8464Z",
    fill: "url(#paint20_linear_3414_10044)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8748 28.1475V26.2485H29.584V30.1935C30.0056 29.2167 30.8436 28.4576 31.8748 28.1475V28.1475Z",
    fill: "url(#paint21_linear_3414_10044)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6079 11.2733C22.7049 11.3731 22.8436 11.4003 22.9693 11.3458C23.095 11.2936 23.1742 11.1712 23.1742 11.0305V10.572C25.0058 10.7332 26.1628 11.7113 26.9121 13.731C26.9298 13.7808 26.9782 13.8081 27.0289 13.8034C27.0796 13.7968 27.1193 13.7559 27.1238 13.7037C27.3066 12.1401 27.0113 10.8854 26.2444 9.97519C25.1931 8.72492 23.6041 8.525 23.1744 8.49331V8.01896C23.1744 7.8785 23.0952 7.75811 22.9695 7.70381C22.9277 7.68551 22.8835 7.67651 22.8417 7.67651C22.7559 7.67651 22.672 7.71045 22.6081 7.7764L21.1447 9.28309C21.0169 9.41691 21.0169 9.63261 21.1447 9.76659L22.6079 11.2733Z",
    fill: "url(#paint22_linear_3414_10044)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7752 30.9334C11.817 30.9515 11.8611 30.9607 11.903 30.9607C11.9888 30.9607 12.0726 30.9266 12.1365 30.8608L13.5999 29.354C13.7277 29.2202 13.7277 29.0046 13.5999 28.8707L12.1365 27.3638C12.0395 27.264 11.9008 27.237 11.7752 27.2913C11.6495 27.3435 11.5703 27.4659 11.5703 27.6067V28.0651C9.73879 27.9038 8.58175 26.926 7.83247 24.9063C7.81485 24.8565 7.76642 24.8292 7.71569 24.8337C7.66497 24.8405 7.62528 24.8814 7.62084 24.9336C7.43801 26.4971 7.73332 27.7519 8.50019 28.6619C9.55147 29.9122 11.1404 30.112 11.5701 30.1437V30.6181C11.5702 30.7587 11.6495 30.8789 11.7751 30.9333L11.7752 30.9334Z",
    fill: "url(#paint23_linear_3414_10044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3414_10044",
    x1: 2.75098,
    y1: 7.29144,
    x2: 17.1899,
    y2: 7.29144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3414_10044",
    x1: 3.64844,
    y1: 18.1043,
    x2: 7.12017,
    y2: 18.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3414_10044",
    x1: 3.64844,
    y1: 11.5093,
    x2: 7.12017,
    y2: 11.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3414_10044",
    x1: 8.23047,
    y1: 18.1043,
    x2: 11.7077,
    y2: 18.1043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3414_10044",
    x1: 8.23047,
    y1: 11.5093,
    x2: 11.7077,
    y2: 11.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3414_10044",
    x1: 12.8179,
    y1: 11.5093,
    x2: 16.2896,
    y2: 11.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3414_10044",
    x1: 13.6582,
    y1: 17.7997,
    x2: 19.8233,
    y2: 17.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3414_10044",
    x1: 4.23926,
    y1: 14.8066,
    x2: 6.53006,
    y2: 14.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3414_10044",
    x1: 8.82324,
    y1: 14.8066,
    x2: 11.114,
    y2: 14.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3414_10044",
    x1: 2.6665,
    y1: 19.9599,
    x2: 14.8527,
    y2: 19.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3414_10044",
    x1: 13.4082,
    y1: 14.408,
    x2: 15.699,
    y2: 14.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3414_10044",
    x1: 18.9272,
    y1: 21.1044,
    x2: 33.3661,
    y2: 21.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3414_10044",
    x1: 19.8247,
    y1: 31.9173,
    x2: 23.2964,
    y2: 31.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3414_10044",
    x1: 19.8247,
    y1: 25.3223,
    x2: 23.2964,
    y2: 25.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3414_10044",
    x1: 24.4067,
    y1: 31.9173,
    x2: 27.884,
    y2: 31.9173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3414_10044",
    x1: 24.4067,
    y1: 25.3223,
    x2: 27.884,
    y2: 25.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3414_10044",
    x1: 28.9937,
    y1: 25.3223,
    x2: 32.4653,
    y2: 25.3223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3414_10044",
    x1: 29.8345,
    y1: 31.6122,
    x2: 35.9997,
    y2: 31.6122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3414_10044",
    x1: 20.4155,
    y1: 28.6197,
    x2: 22.7063,
    y2: 28.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3414_10044",
    x1: 24.9995,
    y1: 28.6197,
    x2: 27.2903,
    y2: 28.6197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3414_10044",
    x1: 18.8428,
    y1: 33.7729,
    x2: 31.029,
    y2: 33.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3414_10044",
    x1: 29.584,
    y1: 28.221,
    x2: 31.8748,
    y2: 28.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3414_10044",
    x1: 21.0488,
    y1: 10.7402,
    x2: 27.1763,
    y2: 10.7402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3414_10044",
    x1: 7.56836,
    y1: 27.897,
    x2: 13.6958,
    y2: 27.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9400D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B0082"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeft);
export default __webpack_public_path__ + "static/media/NEFT.866c0c1ac8048328187ba1c1260d9ade.svg";
export { ForwardRef as ReactComponent };